import React, { useEffect, useState, useRef } from "react";
import "../Stylesheets/Benefits.css";
import AOS from "aos";

const slideData = [
  {
    src: "https://images.unsplash.com/photo-1468436139062-f60a71c5c892?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    title: "Structured Learning",
    copy: [
      "Step-by-Step Curriculum – A well-organized roadmap that takes you from basics to advanced concepts without confusion.",
      "Consistent Progress – Regular assessments and milestones ensure steady learning and measurable growth.",
      "Balanced Approach – A blend of theory, hands-on practice, and mentorship for complete skill development.",
    ],
  },
  {
    src: "https://images.unsplash.com/photo-1531297484001-80022131f5a1?q=80&w=1120&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    title: "Mentorship Support",
    copy: [
      "Guided Learning Path – Experienced mentors provide step-by-step direction to help you understand concepts clearly and apply them effectively.",
      "Personalized Feedback – Regular one-on-one or group sessions ensure doubts are clarified and progress is continuously tracked.",
      "Career Readiness – Mentors share industry insights, interview preparation tips, and real-world practices.",
    ],
  },
  {
    src: "https://images.unsplash.com/photo-1523961131990-5ea7c61b2107?q=80&w=1074&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    title: "Guaranteed Job Placement",
    copy: [
      "Assured Opportunity – Secure a confirmed role with NBMedia after completing the program.",
      "Financial Stability – Enjoy a full year of paid employment while building your career.",
      "Career Growth – Gain real-world experience that sets the foundation for long-term success.",
    ],
  },
  {
    src: "https://images.unsplash.com/photo-1468436139062-f60a71c5c892?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    title: "Complete Tech Stack",
    copy: [
      "IT Industry Relevance – Specialized learning aligned with real-world IT domains such as Web Development, Cloud, Data, and Security.",
      "Hands-On Projects – Build practical solutions that replicate challenges faced in the IT industry.",
      "Career Alignment – Gain domain expertise that directly matches the needs of top IT employers.",
    ],
  },
];

const Benefits = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
    window.scrollTo({ behavior: "smooth", top: 0 });
  }, []);

  const [currentIndex, setCurrentIndex] = useState(0);
  const timeoutRef = useRef(null);

  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      setCurrentIndex((prev) => (prev + 1) % slideData.length);
    }, 5000);

    return () => clearTimeout(timeoutRef.current);
  }, [currentIndex]);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % slideData.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + slideData.length) % slideData.length);
  };

  return (
    <>
      <section className="benefits-section container-fluid my-5 ">
        <div className="row d-flex flex-column align-items-center">
          <div className="col-md-10 position-relative">
            {/* Slider items: image + caption together */}
            {slideData.map((slide, index) => (
              <div
                key={index}
                className={`slide-item ${
                  index === currentIndex ? "active" : ""
                }`}
              >
                <div
                  className="slide-image position-absolute"
                  style={{ backgroundImage: `url(${slide.src})` }}
                  data-aos="fade-down"
                />
                <div
                  className="slide-caption text-white p-5"
                  style={{ maxHeight: "1500px" }}
                >
                  <h2 className="my-3">{slide.title}</h2>

                  <ul className="d-flex flex-column align-items-start list-unstyled mb-5">
                    {slide.copy.map((item, i) => (
                      <li key={i}>
                        {" "}
                        <img
                          alt="check icon"
                          className="icon-check-circle pe-3"
                          src="https://cdn.prod.website-files.com/62a8969da1ab561666c8c408/633afe7b71caab29c5b0d068_material-symbols_check-circle.svg"
                        ></img>
                        {item}
                      </li>
                    ))}
                     <a
                    href="/contact"
                    className="text-light text-decoration-none mt-3 d-flex align-items-center justify-content-center
                     btn-primary-custom"
                  >
                    Enroll Now
                  </a>
                  </ul>                 
                </div>
              </div>
            ))}
          </div>
          {/* Navigation buttons */}
        </div>
      </section>
      <div className="d-flex gap-3">
        <button className="btn btn-outline-light" onClick={prevSlide}>
          &lt;
        </button>
        <button className="btn btn-outline-light" onClick={nextSlide}>
          &gt;
        </button>
      </div>
    </>
  );
};

export default Benefits;
